// extracted by mini-css-extract-plugin
export var dateLabel = "_2u-0";
export var dateLabelError = "_2u-1";
export var fullWidth = "_2u-2";
export var smaller = "_2u-3";